import PropTypes from 'prop-types';
import AboutUsBlock from '../../components/AboutUs/AboutUsBlock';
import { ABOUT_US_QUERY } from '../../components/AboutUs/AboutUsQuery';
import AdobeAnalyticsDataLayer from '../../components/AdobeAnalytics/AdobeAnalyticsDataLayer';
import SeoYoast from '../../components/Seo/SeoYoast';

import { initializeApollo } from '../../utils/apolloClient';

export default function AboutUs({
	id = '',
	date = '',
	modifiedDate = '',
	title = '',
	information = '',
	team = [],
	content = [],
	seo = {},
}) {
	return (
		<>
			<SeoYoast seo={seo} />
			<AdobeAnalyticsDataLayer
				viewType="content"
				contentID={id}
				contentType="page"
				contentCreatedDate={date}
				contentPublishedDate={date}
				contentModifiedDate={modifiedDate}
				contentTitle={title}
			/>
			<AboutUsBlock information={information} team={team} content={content} />
		</>
	);
}

export const getServerSideProps = async () => {
	const apolloClient = initializeApollo();

	const { data } = await apolloClient.query({
		query: ABOUT_US_QUERY,
		variables: {
			id: 'about-us',
			idType: 'URI',
		},
		errorPolicy: 'all',
	});

	if (!data || !data?.page?.aboutUsSettings) {
		return { notFound: true };
	}

	const {
		databaseId,
		modified,
		date,
		title,
	} = data?.page;
	const { aboutUsInformation, aboutUsTeam, aboutUsContent } = data?.page?.aboutUsSettings;
	const { seo } = data?.page;

	return {
		props: {
			id: databaseId,
			date,
			modifiedDate: modified,
			title,
			information: aboutUsInformation,
			team: aboutUsTeam,
			content: aboutUsContent,
			seo,
		},
	};
};

AboutUs.propTypes = {
	id: PropTypes.number,
	date: PropTypes.string,
	modifiedDate: PropTypes.string,
	title: PropTypes.string,
	information: PropTypes.string,
	team: PropTypes.array,
	content: PropTypes.array,
	seo: PropTypes.object,
};
